export { default } from './PromotionalMessage'
